import type { TableSortState } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import type {
  CaseCommunicationFeedSortDirection,
  CaseCommunicationFeedSortField,
} from "../../../../../../../../api/kehrblatt/case-communications"

export type CommunicationPlanFeedSort = {
  sortBy: CaseCommunicationFeedSortField
  sortDirection: CaseCommunicationFeedSortDirection
}

export const GLOBAL_COMMUNICATION_PLAN_DEFAULT_SORT: NonNullable<TableSortState> = {
  columnId: "contact",
  key: "effective_at",
  dir: "desc",
}

export const SCOPED_COMMUNICATION_PLAN_DEFAULT_SORT: NonNullable<TableSortState> = {
  columnId: "contact",
  key: "effective_at",
  dir: "asc",
}

export const communicationPlanFeedSort = (
  sort: TableSortState,
  organizationScope: boolean,
): CommunicationPlanFeedSort => {
  const fallback = organizationScope
    ? GLOBAL_COMMUNICATION_PLAN_DEFAULT_SORT
    : SCOPED_COMMUNICATION_PLAN_DEFAULT_SORT
  const candidate = sort ?? fallback

  return {
    sortBy: candidate.key === "work_order_number" ? "work_order_number" : "effective_at",
    sortDirection: candidate.dir === "desc" ? "desc" : "asc",
  }
}

export const communicationPlanFeedSortKey = (sort: CommunicationPlanFeedSort): string =>
  `${sort.sortBy}:${sort.sortDirection}`
